import React, { Component } from "react";
import { connect } from "react-redux";
import { Layer, Group, Rect, RegularPolygon, Circle } from "react-konva";
import {
  addLeft,
  addTop,
  addRight,
  addDown,
  addCenter,
  removeLeft,
  removeTop,
  removeRight,
  removeDown,
  removeCenter,
  setNewPosition
} from "../../actions/add-remove-tool-actions";
import {
  GLOBAL_DRAWING_MODE_ADD,
  GLOBAL_DRAWING_MODE_REMOVE,
  GLOBAL_DRAWING_MODE_INLET_MANIFOLD,
  GLOBAL_DRAWING_MODE_INSERTA_TEE,
  GLOBAL_DRAWING_MODE_INSPECTION_PORT,
  GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD,
  MSG_INVALID_DRAWING_MODE_ERROR
} from "../../lib/types";

/* direction constants */
const RIGHT = "Right";
const LEFT = "Left";
const TOP = "Top";
const DOWN = "Down";
const CENTER = "Center";

/**
 * Right click add/remove tool react component.
 */
class AddRemoveTool extends Component {
  handleOnDragEnd() {
    /* dispatch moved action */
    this.props.setNewPosition(this.groupNode.x(), this.groupNode.y());
  }
  handleOnMouseEnter(button) {
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_ADD:
        button.fill("#106EBE");
        break;
      case GLOBAL_DRAWING_MODE_REMOVE:
        button.fill("#FF0000");
        break;
      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
        button.fill("#00FFFF");
        break;
      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
        button.fill("#ADFF2F");
        break;
      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD:
        button.fill("#ff7f50");
        break;
      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD:
        button.fill("#6495ED");
        break;
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
    button.getLayer().batchDraw();
  }
  handleOnMouseLeave(button) {
    button.fill("orange");
    button.getLayer().batchDraw();
  }
  handleAddRemoveClick(direction) {
    /* the opearation name variable */
    let operationPrefix;
    /* check which action to call by building operation and direction
    function name */
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_ADD:
        operationPrefix = "add";
        break;
      case GLOBAL_DRAWING_MODE_REMOVE:
        operationPrefix = "remove";
        break;
      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
        operationPrefix = "toggle inserta-tee accessory";
        break;
      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
        operationPrefix = "toggle inspection-port accessory";
        break;
      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD:
        operationPrefix = "toggle inlet manifold accessory";
        break;
      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD:
        operationPrefix = "toggle outlet manifold accessory";
        break;
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
    /* call the corresponding action with target chamber row and column, example
    this.props.removeLeft(1,2) will remove the chamber on the left of
    chamber in row 1 column 2 */
    let operation = `${operationPrefix}${direction}`;
    this.props[operation](
      this.props.selectedChamberRow,
      this.props.selectedChamberCol
    );
  }
  handleCircleOnMouseEnter() {
    this.circleNode.getStage().container().style.cursor = "move";
  }
  handleCircleOnMouseLeave() {
    this.circleNode.getStage().container().style.cursor = "default";
  }
  useOwnCoodinates() {
    return this.props.x > 0 || this.props.y > 0;
  }
  isVisible() {
    return (
      this.props.selectedChamberRow >= 0 &&
      this.props.selectedChamberCol >= 0 &&
      this.props.selectedChamberRow < this.props.chamberBedNumOfRows &&
      this.props.selectedChamberCol < this.props.chamberBedNumOfChambers
    );
  }
  render() {
    return (
      <Layer visible={this.isVisible()}>
        <Group
          height={this.props.height}
          width={this.props.width}
          x={
            this.useOwnCoodinates() ? this.props.x : this.props.chamberBedX + 10
          }
          y={this.useOwnCoodinates() ? this.props.y : this.props.chamberBedY}
          rotation={this.props.rotation - 90}
          draggable={true}
          onDragEnd={() => {
            this.handleOnDragEnd();
          }}
          ref={node => {
            this.groupNode = node;
          }}
        >
          <Circle
            x={this.props.height / 2}
            y={this.props.height / 2}
            radius={this.props.height / 2}
            stroke={"orange"}
            fill={"#F9F9FA"}
            strokeWidth={2}
            onMouseEnter={() => this.handleCircleOnMouseEnter()}
            onMouseLeave={() => this.handleCircleOnMouseLeave()}
            ref={node => {
              this.circleNode = node;
            }}
          />
          <RegularPolygon
            x={this.props.width / 7}
            y={this.props.height / 2}
            rotation={-90}
            sides={3}
            radius={this.props.width / 8}
            fill={"orange"}
            stroke={"gray"}
            strokeWidth={1}
            onClick={() => {
              this.handleAddRemoveClick(LEFT);
            }}
            onMouseEnter={() => this.handleOnMouseEnter(this.leftButton)}
            onMouseLeave={() => this.handleOnMouseLeave(this.leftButton)}
            ref={node => {
              this.leftButton = node;
            }}
          />
          <RegularPolygon
            x={this.props.width / 3}
            y={this.props.height / 4.5}
            rotation={0}
            sides={3}
            radius={this.props.width / 8}
            fill={"orange"}
            stroke={"gray"}
            strokeWidth={1}
            onClick={() => {
              this.handleAddRemoveClick(TOP);
            }}
            onMouseEnter={() => this.handleOnMouseEnter(this.upButton)}
            onMouseLeave={() => this.handleOnMouseLeave(this.upButton)}
            ref={node => {
              this.upButton = node;
            }}
          />
          <RegularPolygon
            x={this.props.width / 1.95}
            y={this.props.height / 2}
            rotation={90}
            sides={3}
            radius={this.props.width / 8}
            fill={"orange"}
            stroke={"gray"}
            strokeWidth={1}
            onClick={() => {
              this.handleAddRemoveClick(RIGHT);
            }}
            onMouseEnter={() => this.handleOnMouseEnter(this.rightNode)}
            onMouseLeave={() => this.handleOnMouseLeave(this.rightNode)}
            ref={node => {
              this.rightNode = node;
            }}
          />
          <RegularPolygon
            x={this.props.width / 3}
            y={this.props.height / 1.28}
            rotation={180}
            sides={3}
            radius={this.props.width / 8}
            fill={"orange"}
            stroke={"gray"}
            strokeWidth={1}
            onClick={() => {
              this.handleAddRemoveClick(DOWN);
            }}
            onMouseEnter={() => this.handleOnMouseEnter(this.downButton)}
            onMouseLeave={() => this.handleOnMouseLeave(this.downButton)}
            ref={node => {
              this.downButton = node;
            }}
          />
          <Rect
            x={this.props.width / 4.5}
            y={this.props.height / 3}
            height={this.props.height / 3}
            width={this.props.width / 4.8}
            fill={"orange"}
            stroke={"gray"}
            strokeWidth={1}
            onClick={() => {
              this.handleAddRemoveClick(CENTER);
            }}
            onMouseEnter={() => this.handleOnMouseEnter(this.centerButton)}
            onMouseLeave={() => this.handleOnMouseLeave(this.centerButton)}
            ref={node => {
              this.centerButton = node;
            }}
          />
        </Group>
      </Layer>
    );
  }
}

const mapStateToProps = state => {
  return {
    x: state.addremovetool.x,
    y: state.addremovetool.y,
    height: state.addremovetool.height,
    width: state.addremovetool.width,

    drawingMode: state.globals.drawingMode,

    rotation: state.chamberbed.rotation,
    chamberBedX: state.chamberbed.x,
    chamberBedY: state.chamberbed.y,
    chamberBedNumOfRows: state.chamberbed.numOfRows,
    chamberBedNumOfChambers: state.chamberbed.numOfChambers,
    selectedChamberRow: state.chamberbed.selectedChamberRow,
    selectedChamberCol: state.chamberbed.selectedChamberCol
  };
};
/* export this contained component */
export default connect(
  mapStateToProps,
  {
    /** Actions Go Here */
    addLeft,
    addTop,
    addRight,
    addDown,
    addCenter,
    removeLeft,
    removeTop,
    removeRight,
    removeDown,
    removeCenter,
    setNewPosition
  }
)(AddRemoveTool);



// WEBPACK FOOTER //
// ./src/components/Drawings/add-remove-tool.js